import React, { useRef } from 'react';
import { Button, Content } from 'rsuite';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import styles from './HistoryPriceOutOfRangeChart.module.scss';
import { OptionsDropdown } from '../OptionsDropdown';
import { OPTIONS_DROPDOWN } from '../../data';
import { useAderenciaPrecosStore } from '../../AderenciaPrecos.store';
import { HistorySerieDataPoint } from '../../types';
import { LoadingSpinerArea, LoadingSpinerLocal } from '../../../../../../components';
import iconPoint from '../../../../../../assets/icons/series-icon-chart.svg';

type HistoryPriceOutOfRangeChartProps = {
  className?: string;
  data?: Highcharts.SeriesOptionsType[];
  isLoading?: boolean;
};

const chartData = (percentual: HistorySerieDataPoint[], quantidade: HistorySerieDataPoint[]) => [
  {
    color: '#D53B3B',
    data: percentual,
    name: 'PERCENTUAL DE PREÇOS FORA DO RANGE',
    type: 'spline',
    yAxis: 1,
    zIndex: 1,
  },
  {
    color: '#A7CFFF',
    data: quantidade,
    name: 'DATAPOINTS',
    type: 'column',
    yAxis: 0,
  },
];

export const HistoryPriceOutOfRangeChart = ({ className, data, isLoading }: HistoryPriceOutOfRangeChartProps) => {
  const { historyPercentualForaRange, historyQuantidadeDataPoint } = useAderenciaPrecosStore();

  const chartRef = useRef(null);

  const graficoData = {
    exporting: {
      enabled: false,
    },
    chart: {
      type: 'column',
      height: 260,
    },
    title: {
      text: '',
    },
    xAxis: {
      type: 'datetime',
      startOfWeek: 0,
      labels: {
        allowOverlap: true,
        padding: 0,
        format: '{value: %d/%m/%Y}',
      },
    },
    yAxis: [
      {
        // LADO DIREITO
        title: {
          text: 'QUANTIDADE DE DATAPOINTS',
        },
        breakSize: 1,
        alignTicks: false,
        opposite: true,
      },
      {
        // LADO ESQUERDO
        max: 100,
        title: {
          text: 'PERCENTUAL DE PREÇOS FORA DO RANGE',
        },
        labels: {
          formatter: (props: any) => `${props.value}%`,
        },
        alignTicks: false,
      },
    ],
    tooltip: {
      useHTML: true,
      pointFormatter: function () {
        const datapointStyle = 'width: 12px; height: 12px; background-color: #A7CFFF; color: #A7CFFF; border-radius: 50px; margin: 0 14px 0 8px;';
        const percentualStyle = 'font-weight: bold; margin-right: 56px';
        const iconStyle = 'margin-right: 6px;';

        const isPercentual = `<img src="${iconPoint}" style="${iconStyle}"/><span style="${percentualStyle}">${this.series.name}: ${this.y}%</span><br/>`;
        const isDatapoints = `<div style="display: flex; align-items: center;">
            <div style="${datapointStyle}"></div><span style="font-weight: bold">${this.series.name}: ${this.y}</span><br/>
          </div>
        `;

        if (this.series.name === 'PERCENTUAL DE PREÇOS FORA DO RANGE') {
          return isPercentual;
        }

        if (this.series.name === 'DATAPOINTS') {
          return isDatapoints;
        }
      },
      // pointFormat: '<span style="color:{series.color}">● </span>' + '<span>{series.name}</span>' + ': <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
      shared: true,
      headerFormat: '<b>{point.key}</b><br/>',
      xDateFormat: '%d/%m/%Y',
    },
    plotOptions: {
      series: {
        lineWidth: 1,
        marker: {
          radius: 3,
        },
      },
    },
    series: chartData(historyPercentualForaRange, historyQuantidadeDataPoint),
  };

  const handleClickDownload = (type: 'CSV' | 'XLS') => {
    if (type === 'CSV') {
      chartRef.current.chart.downloadCSV();
    } else {
      chartRef.current.chart.downloadXLS();
    }
  };

  return (
    <Content className={`${styles['product-by-range-chart-box-container']} ${className}`}>
      <LoadingSpinerArea area="aderencia-history" size="md" style={{ position: 'absolute' }} />
      <div className={styles['header-container']}>
        <p className={styles.title}>HISTÓRICO DE PREÇOS fora DO RANGE</p>
        <OptionsDropdown id="detailing-more-options" data={OPTIONS_DROPDOWN} onClick={handleClickDownload} />
      </div>
      <div className={styles['period-break-container']}>
        <span className={styles['period-break-title']}>Quebra de período: </span>
        <Button appearance="subtle" className={styles['select-period-btn']}>
          Semanal
        </Button>
      </div>
      <div className={styles['chart-container']}>
        {historyPercentualForaRange.length > 0 && historyQuantidadeDataPoint.length > 0 ? (
          <HighchartsReact ref={chartRef} highcharts={Highcharts} options={graficoData} />
        ) : null}
      </div>
    </Content>
  );
};
